import * as React from "react"
import Svg, { Path, Mask } from "react-native-svg"
import type { SvgProps } from "react-native-svg"

function SvgComponent(props: SvgProps) {
    return (
        <Svg
            width={26}
            height={26}
            viewBox="0 0 25 24"
            fill="none"
            {...props}
        >
            <Path
                d="M11 21a9 9 0 100-18 9 9 0 000 18z"
                stroke="#9490B1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                d="M14 14a3.78 3.78 0 01-1.268 1.464A3.115 3.115 0 0111 16a3.115 3.115 0 01-1.732-.536A3.78 3.78 0 018 14"
                stroke="#9490B1"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <Path
                d="M7.625 11.577a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25zM14.375 11.577a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z"
                fill="#9490B1"
            />
            <Mask
                id="a"
                maskUnits="userSpaceOnUse"
                x={13.0048}
                y={1}
                width={11}
                height={11}
                fill="#000"
            >
                <Path fill="#fff" d="M13.0048 1H24.0048V12H13.0048z" />
                <Path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.505 3a.5.5 0 00-.5.5V6h-2.5a.5.5 0 000 1h2.5v2.5a.5.5 0 001 0V7h2.5a.5.5 0 100-1h-2.5V3.5a.5.5 0 00-.5-.5z"
                />
            </Mask>
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.505 3a.5.5 0 00-.5.5V6h-2.5a.5.5 0 000 1h2.5v2.5a.5.5 0 001 0V7h2.5a.5.5 0 100-1h-2.5V3.5a.5.5 0 00-.5-.5z"
                fill="#9490B1"
            />
            <Path
                d="M18.005 6v2h2V6h-2zm0 1h2V5h-2v2zm1 0V5h-2v2h2zm0-1h-2v2h2V6zm1-2.5a1.5 1.5 0 01-1.5 1.5V1a2.5 2.5 0 00-2.5 2.5h4zm0 2.5V3.5h-4V6h4zm-4.5 2h2.5V4h-2.5v4zm1.5-1.5a1.5 1.5 0 01-1.5 1.5V4a2.5 2.5 0 00-2.5 2.5h4zm-1.5-1.5a1.5 1.5 0 011.5 1.5h-4a2.5 2.5 0 002.5 2.5V5zm2.5 0h-2.5v4h2.5V5zm2 4.5V7h-4v2.5h4zm-1.5-1.5a1.5 1.5 0 011.5 1.5h-4a2.5 2.5 0 002.5 2.5V8zm-1.5 1.5a1.5 1.5 0 011.5-1.5v4a2.5 2.5 0 002.5-2.5h-4zm0-2.5v2.5h4V7h-4zm4.5-2h-2.5v4h2.5V5zm-1.5 1.5a1.5 1.5 0 011.5-1.5v4a2.5 2.5 0 002.5-2.5h-4zm1.5 1.5a1.5 1.5 0 01-1.5-1.5h4a2.5 2.5 0 00-2.5-2.5v4zm-2.5 0h2.5V4h-2.5v4zm-2-4.5V6h4V3.5h-4zm1.5 1.5a1.5 1.5 0 01-1.5-1.5h4a2.5 2.5 0 00-2.5-2.5v4z"
                fill="#fff"
                mask="url(#a)"
            />
        </Svg>
    )
}

export default SvgComponent
